(() => {
  function initializeGreekCustomizer(root) {
    if (!root || root.dataset.greekPickerReady === 'true') return;
    root.dataset.greekPickerReady = 'true';

    const input = root.querySelector('.greek-customizer__text-input');
    const symbolButtons = Array.from(root.querySelectorAll('[data-greek-symbol]'));
    const deleteButton = root.querySelector('[data-greek-delete]');
    const clearButton = root.querySelector('[data-greek-clear]');
    const maximum = Number(input?.maxLength || 3);

    if (!input || !symbolButtons.length) return;

    function symbols() {
      return Array.from(input.value);
    }

    function notifyCustomizer() {
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }

    function updateControls() {
      const selected = symbols();
      const atLimit = selected.length >= maximum;
      symbolButtons.forEach((button) => {
        button.disabled = atLimit;
      });
      deleteButton.disabled = selected.length === 0;
      clearButton.disabled = selected.length === 0;
    }

    symbolButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const selected = symbols();
        if (selected.length >= maximum) return;
        input.value = `${input.value}${button.dataset.greekSymbol}`;
        notifyCustomizer();
        updateControls();
      });
    });

    deleteButton.addEventListener('click', () => {
      input.value = symbols().slice(0, -1).join('');
      notifyCustomizer();
      updateControls();
    });

    clearButton.addEventListener('click', () => {
      input.value = '';
      notifyCustomizer();
      updateControls();
    });

    input.addEventListener('input', updateControls);
    updateControls();
  }

  function initializeAll() {
    document.querySelectorAll('ice-text-customizer.greek-customizer').forEach(initializeGreekCustomizer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', initializeAll);
})();
